import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getConfig } from "../../utils";
import initialState from "../initial-state";

type LayoutSize = { width: number; height: number; pixelRatio: number };
export type Layout = { name: string } & LayoutSize;

export const resize = createAsyncThunk(
  "layout/resize",
  async (data: LayoutSize) => {
    const config = await getConfig();
    const findLayoud = (cfg: { [name: string]: number }, ratio: number) => {
      return Object.keys(cfg).reduce((layout, key) => {
        return !layout && ratio < cfg[key] ? key : layout;
      }, "");
    };
    const name = findLayoud(config.layouts, data.width / data.height);
    const pixelRatio = Math.min(data.pixelRatio, 2);

    return { ...data, name, pixelRatio };
  }
) as any;

const layout = createSlice({
  name: "layout",
  initialState: initialState.layout,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resize.fulfilled, (_, action: PayloadAction<Layout>) => {
      return action.payload;
    });
  },
});

export default layout;
